import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=bdc580dc&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=bdc580dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc580dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdc580dc')) {
      api.createRecord('bdc580dc', component.options)
    } else {
      api.reload('bdc580dc', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=bdc580dc&scoped=true&", function () {
      api.rerender('bdc580dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Kpz1URqTuh3J/JS/comp/DateRange.vue"
export default component.exports